var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1441,
    height: 1218,
    viewBox: "0 0 1441 1218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 573,
    cy: 273,
    r: 3,
    transform: "rotate(-90 573 273)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 573,
    cy: 90,
    r: 3,
    transform: "rotate(-90 573 90)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1320,
    cy: 77,
    r: 3,
    transform: "rotate(-90 1320 77)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 865,
    cy: 29,
    r: 3,
    transform: "rotate(-90 865 29)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1141,
    cy: 13,
    r: 3,
    transform: "rotate(-90 1141 13)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1005,
    cy: 101,
    r: 3,
    transform: "rotate(-90 1005 101)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1213,
    cy: 201,
    r: 3,
    transform: "rotate(-90 1213 201)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 44,
    r: 3,
    transform: "rotate(-90 370 44)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 129,
    r: 3,
    transform: "rotate(-90 216 129)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 6,
    r: 3,
    transform: "rotate(-90 122 6)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 202,
    r: 3,
    transform: "rotate(-90 83 202)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 305,
    r: 3,
    transform: "rotate(-90 206 305)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 414,
    cy: 186,
    r: 3,
    transform: "rotate(-90 414 186)",
    fill: "white",
    fillOpacity: 0.25
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.5,
    cy: 477,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 558.5,
    cy: 918,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 682.5,
    cy: 663,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 682.5,
    cy: 1071,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 666.5,
    cy: 1215,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 566.5,
    cy: 987,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 634.5,
    cy: 833,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 523.5,
    cy: 460,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 411.5,
    cy: 536,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 669.5,
    cy: 530,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 323.5,
    cy: 430,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.5,
    cy: 1086,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 159.5,
    cy: 747,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.5,
    cy: 867,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 695,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 875,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 816.5,
    cy: 509,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 1210.5,
    cy: 918,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 1314.5,
    cy: 663,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 1346.5,
    cy: 795,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 1286.5,
    cy: 833,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 1175.5,
    cy: 472,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 1267.5,
    cy: 380,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 1063.5,
    cy: 536,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 1337.5,
    cy: 530,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 975.5,
    cy: 434,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 811.5,
    cy: 747,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 735.5,
    cy: 887,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 799.5,
    cy: 643,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 850.5,
    cy: 875,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 1290.5,
    cy: 973.5,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 1202.5,
    cy: 1057.5,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 1327.5,
    cy: 1213.5,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.ec576070b06ce1da97b4b1a10921cab6.svg";
export { ForwardRef as ReactComponent };